<template>
  <v-container>
    <v-card class="pa-8 mx-auto" max-width="900">
      <!-- タイトル -->
      <v-row class="mb-6">
        <v-col class="text-center">
          <h2 class="text-h5 font-weight-bold mb-2">
            申込内容の詳細
          </h2>
        </v-col>
      </v-row>

      <!-- 詳細内容表示 -->
      <v-row v-if="formData" class="mb-4">
        <v-col cols="12">
          <edi-confirm-table :form-data="formData" />
        </v-col>
      </v-row>

      <!-- ローディング表示 -->
      <v-row v-else class="mb-4">
        <v-col cols="12" class="text-center">
          <v-progress-circular
            indeterminate
            color="primary"
          />
        </v-col>
      </v-row>

      <v-divider class="my-6" />

      <!-- フッターボタン -->
      <v-row class="mt-8">
        <v-col :cols="canDelete ? 4 : 6">
          <v-btn
            block
            large
            outlined
            @click="handleClose"
          >
            閉じる
          </v-btn>
        </v-col>
        <v-col v-if="canDelete" cols="4">
          <v-btn
            block
            large
            color="error"
            outlined
            @click="handleDelete"
          >
            削除
          </v-btn>
        </v-col>
        <v-col :cols="canDelete ? 4 : 6">
          <v-btn
            block
            large
            color="primary"
            @click="handleEdit"
          >
            編集
          </v-btn>
        </v-col>
      </v-row>
    </v-card>
    <confirm ref="confirm" />
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'
import EdiConfirmTable from '@/components/EdiConfirmTable'
import Confirm from '../../components/Confirm'

export default {
  name: 'EdiRequestUnsubscribedShow',
  components: {
    EdiConfirmTable,
    Confirm,
  },
  props: {
    ediRequestId: {
      type: [Number, String],
      required: true
    }
  },
  data() {
    return {
      formData: null,
      ediStatus: null
    }
  },
  computed: {
    canDelete() {
      return this.ediStatus === 'emission_requested' || this.ediStatus === 'jwnet_requested'
    }
  },
  created() {
    this.fetchShowData()
  },
  methods: {
    ...mapActions('EdiRequestUnsubscribed', {
      fetchShow: 'show',
      destroyUnsubscribed: 'destroy',
    }),
    fetchShowData() {
      const id = this.ediRequestId
      this.fetchShow({ id }).then(content => {
        // EDIステータスを保存
        this.ediStatus = content.edi_status
        // APIから取得したデータをformDataに設定
        this.formData = {
          id: content.id,
          jwnet_name: content.jwnet_name,
          corporation_code: content.corporation_code,
          corporate_designation_type: content.corporate_designation_type,
          emission_name: content.emission_name,
          emission_name_kana: content.emission_name_kana,
          emission_location_name: content.emission_location_name,
          emission_location_name_kana: content.emission_location_name_kana,
          representative_last_name: content.representative_last_name,
          representative_first_name: content.representative_first_name,
          representative_last_name_kana: content.representative_last_name_kana,
          representative_first_name_kana: content.representative_first_name_kana,
          zip_code: content.zip_code,
          prefecture_code: content.prefecture_code,
          address_1: content.address_1,
          address_2: content.address_2,
          address_3: content.address_3,
          phone_number: content.phone_number,
          same_as_representative: content.same_as_representative,
          contact_last_name: content.contact_last_name,
          contact_first_name: content.contact_first_name,
          contact_last_name_kana: content.contact_last_name_kana,
          contact_first_name_kana: content.contact_first_name_kana,
          contact_phone_number: content.contact_phone_number,
          email: content.email,
          transport_name: content.transport_name,
          industry_code: content.industry_code,
          visibility_type: content.visibility_type,
          visibility_url: content.visibility_url,
        }
      }).catch(error => {
        console.error('データの取得に失敗しました', error)
        this.$router.push({ name: 'AdminEdiRequests' })
      })
    },
    handleClose() {
      // 一覧画面に戻る
      this.$router.push({ name: 'AdminEdiRequests' })
    },
    handleEdit() {
      // 編集画面に遷移
      this.$router.push({
        name: 'EdiRequestUnsubscribedEdit',
        params: { id: this.ediRequestId }
      })
    },
    handleDelete() {
      this.$refs.confirm.showDeleteConfirm().then((confirm) => {
        this.$refs.confirm.close()
        if (confirm) {
          const id = this.ediRequestId
          this.destroyUnsubscribed({ id }).then(() => {
            this.$router.push({ name: 'AdminEdiRequests' })
          }).catch(error => {
            console.error('削除に失敗しました', error)
          })
        }
      })
    }
  }
}
</script>
